import { ButtonLoading } from 'components/Buttons'
import FormattedMessage from 'utils/FormattedMessage'
import { useUpdateCheck } from 'utils/useUpdateCheck'

export const UpdateModal = () => {
  const updateAvailable = useUpdateCheck()

  if (!updateAvailable) return null

  return (
    <div className='fixed inset-0 z-[9998] flex items-center justify-center px-4'>
      <div className='absolute inset-0 bg-gray-500 bg-opacity-75' />
      <div className='relative flex flex-col items-center bg-white rounded-lg shadow-xl px-8 py-10 w-full max-w-sm'>
        <h1 className='text-gray-700 text-2xl font-bold text-center'>
          <FormattedMessage id='updateModal.title' />
        </h1>
        <p className='text-sm text-gray-800 text-center my-5 max-w-[85%]'>
          <FormattedMessage id='updateModal.description' />
        </p>
        <ButtonLoading onClick={() => window.location.reload()} style='w-full !mb-0 mt-4'>
          <FormattedMessage id='updateModal.submit' />
        </ButtonLoading>
      </div>
    </div>
  )
}
